<template>
    <RevealBehaviorTile
        ref="tileComponent"
        :reveal-behavior="revealBehavior"
        :reveal-icon="revealIcon"
        :children="children"
        :initially-toggled="initiallyToggled"
        item-class="repeatable-container-item"
        test-id-prefix="repeatable-container"
        class="repeatable-container-tile"
        data-testid="list-element"
    >
        <template
            v-if="allowRemove"
            #extra-buttons
        >
            <div
                class="container-minor-btn"
                :class="{ disabled: removeDisabled }"
                @click="emit('remove-item', itemIndex)"
            >
                <LoadingCircle v-if="removing" />
                <i
                    v-else
                    :class="removeIcon || 'mi-close'"
                />
            </div>
        </template>
    </RevealBehaviorTile>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { TooltipBlockDecorator, useBlockDecorators } from 'widget-components/integrations/CustomPage'
import type {
    ExtendedBlock,
    RepeatableContainerIterationAddedEvent,
    RevealBehavior,
} from 'widget-components/integrations/CustomPage/types'
import { useEventBus } from '@vueuse/core'
import LoadingCircle from '../LoadingCircle/LoadingCircle.vue'
import RevealBehaviorTile from 'widget-components/components/RevealBehaviorTile/RevealBehaviorTile.vue'

useBlockDecorators(TooltipBlockDecorator)

const props = withDefaults(defineProps<{
    children: ExtendedBlock[]
    itemIndex: number
    parentId: string
    revealBehavior?: RevealBehavior
    initiallyToggled?: boolean
    allowRemove?: boolean
    removeIcon?: string
    revealIcon?: string
    removing: boolean
    removeDisabled?: boolean
}>(), {
    revealBehavior: 'INLINE_COLLAPSED',
    initiallyToggled: false,
    allowRemove: false,
})

const emit = defineEmits(['download-document', 'remove-item'])

const tileComponent = ref<InstanceType<typeof RevealBehaviorTile>>()

useEventBus<RepeatableContainerIterationAddedEvent>('repeatable-container:iteration-added')
    .on(({ block, newIterationIndex }) => {
        if (props.parentId === block.id && newIterationIndex === props.itemIndex) {
            tileComponent.value!.autoReveal()
        }
    })
</script>

<style lang="sass" scoped>
@import "./RepeatableContainer.sass"
</style>
